import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from 'react';
import { useTranslation } from 'react-i18next';
import withMemo from '../../decorators/withMemo';
import SubmitSchoolTemplate from '../../templates/SubmitSchool';
import { useHeader, useFooter } from '../../hooks/useAppLayout';
import { useNavPath } from '../../hooks/useNavPath';
import sagas from './sagas';
var SubmitSchool = function SubmitSchool() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var headerProps = useHeader();
  var footerProps = useFooter();
  var navPathProps = useNavPath();
  var layoutProps = {
    theme: {
      maxWidth: 640
    }
  };
  var pageTitleProps = {
    text: t('submit_your_school')
  };
  var paragraphProps = {
    text: t('submitschool_page_introduction')
  };
  var submitSchoolTemplateProps = {
    headerProps: headerProps,
    navPathProps: navPathProps,
    footerProps: footerProps,
    layoutProps: layoutProps,
    pageTitleProps: pageTitleProps,
    paragraphProps: paragraphProps
  };
  return /*#__PURE__*/React.createElement(SubmitSchoolTemplate, submitSchoolTemplateProps);
};
SubmitSchool.getInitialProps = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(ctx) {
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", ctx.store.saga.run(sagas.init, ctx).toPromise());
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x) {
    return _ref.apply(this, arguments);
  };
}();
SubmitSchool.propTypes = {};
SubmitSchool.defaultProps = {};
export default withMemo()(SubmitSchool);